
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/build-your-shop-on-whatsapp",
      function () {
        return require("private-next-pages/build-your-shop-on-whatsapp.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/build-your-shop-on-whatsapp"])
      });
    }
  